"use strict";
function showNote(message, className) {
    var div = document.createElement("div");
    div.setAttribute("data-qa", "notification");
    div.className = className;
    div.textContent = message;
    document.body.append(div);
}
var promise1 = new Promise(function(resolve, reject) {
    var id = setTimeout(function() {
        return reject(new Error("First promise was rejected"));
    }, 3000);
    document.addEventListener("click", function() {
        resolve("First promise was resolved");
        clearTimeout(id);
    }, {
        once: true
    });
});
var promise2 = new Promise(function(resolve, reject) {
    document.addEventListener("click", function() {
        resolve("Second promise was resolved");
    }, {
        once: true
    });
    document.addEventListener("contextmenu", function(e) {
        e.preventDefault();
        resolve("Second promise was resolved");
    }, {
        once: true
    });
});
var leftClickPromise = new Promise(function(resolve, reject) {
    document.addEventListener("click", function() {
        resolve("Third promise was resolved");
    }, {
        once: true
    });
});
var rightClickPromise = new Promise(function(resolve, reject) {
    document.addEventListener("contextmenu", function(e) {
        e.preventDefault();
        resolve();
    }, {
        once: true
    });
});
var promise3 = Promise.all([
    leftClickPromise,
    rightClickPromise
]);
promise1.then(function(message) {
    return showNote(message, "success");
}).catch(function(error) {
    return showNote(error.message, "error");
});
promise2.then(function(message) {
    return showNote(message, "success");
});
promise3.then(function() {
    return showNote("Third promise was resolved", "success");
});

//# sourceMappingURL=index.ce94e6f0.js.map
